import morphism, { StrictSchema } from 'morphism'
import { getRequest, urlBuilder } from 'tfs.front-end-utils/requests'
import { MiddlewareAPI, Dispatch, Action } from 'redux'

import ClientSSRInterface from '../../interfaces/client/SSR'
import ServerSSRInterface from '../../interfaces/server/SSR'

import ssrSchema from '../../schemas/client/SSR'

import staticData from '../../config/staticData'

import formatErrors from '../../utils/errors/formatErrors'
import getAuthenticationHeaders from '../../utils/requests/generateAuthorizationHeaders'
import { customTourOperatorParameters } from '../../utils/tourOperators'

import { v1receiveSSRList } from '../../actions/ssrs'
import { V1_REQUEST_SSR_LIST } from '../../actions/ssrs/v1requestSSRList'
import v1throwError from '../../actions/errors/v1throwError'

import fetchSSRsTranslations from './fetchSSRsTranslations'

export interface SSRsAction extends Action {
  flightId: string
}

export default (store: MiddlewareAPI) => (next: Dispatch) => async (
  action: SSRsAction
) => {
  next(action)

  if (action.type !== V1_REQUEST_SSR_LIST) {
    return
  }
  const dispatch = store.dispatch

  const {
    endpoints: {
      ssrs: { url, headers },
    },
  } = staticData
  const authHeaders = await getAuthenticationHeaders(headers)

  try {
    const fixedUrl = url.endsWith('/') ? url : `${url}/`
    const requestUrl = urlBuilder(
      `${fixedUrl}${action.flightId}`,
      customTourOperatorParameters()
    )
    const ssrsResponse = await getRequest(
      requestUrl,
      { headers: { ...headers, ...authHeaders } },
      { requestCollection: true },
      formatErrors
    )

    const formattedSSRs = ssrsResponse.map((ssr: ServerSSRInterface) =>
      morphism<StrictSchema<ClientSSRInterface, ServerSSRInterface>>(
        ssrSchema,
        ssr
      )
    )

    dispatch(v1receiveSSRList(formattedSSRs))

    const translatedSSRs = await fetchSSRsTranslations(formattedSSRs)

    if (translatedSSRs.length) {
      dispatch(v1receiveSSRList(translatedSSRs))
    }
  } catch (error) {
    dispatch(v1throwError(error))
  }
}
